import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid,
  ReferenceLine
} from 'recharts';
import { Typography, Paper } from '@mui/material';
import dayjs from 'dayjs';

const PriceChart = ({ data, targetPrice, currency }) => {
  // Preprocess data: parse price to number, format date
  const chartData = [];
  let lastPrice = null;
  let lastDay = null;

  data.forEach(entry => {
    const price = parseFloat(entry.price);
    const createdAt = dayjs(entry.createdAt).local();
    const day = createdAt.format('DD/MM'); // You could also use YYYY-MM-DD

    // Only include if price changed or it's a new day
    if (price !== lastPrice) {
      chartData.push({
        price,
        displayTime: day,
        fullTime: createdAt.format('DD/MM/YYYY HH:mm'),
      });
      lastPrice = price;
      lastDay = day;
    }
  });

  const renderTimeProportionalXAxis = () => {
    // Preprocess data: parse price to number, format date
    const chartData = [];
    let lastPrice = null;
    let lastDay = null;
  
    data.forEach(entry => {
      const price = parseFloat(entry.price);
      const createdAt = dayjs(entry.createdAt).local();
      const day = createdAt.format('DD/MM'); // You could also use YYYY-MM-DD
  
      // Only include if price changed or it's a new day
      if (price !== lastPrice || day !== lastDay) {
        chartData.push({
          price,
          timestamp: createdAt.valueOf(),
          fullTime: createdAt.format('DD/MM/YYYY HH:mm'),
        });
        lastPrice = price;
        lastDay = day;
      }
    });
    return (
      <XAxis 
        dataKey="timestamp" 
        type='number'
        domain={['dataMin', 'dataMax']}
        tickFormatter={(time) => dayjs(time).format('DD/MM')}
        tick={{ fontSize: 12 }}
        scale="time"
      />
    )
  }


  return (
    <Paper sx={{ p: 2, mt: 4 }}>
      <Typography variant="h6" gutterBottom sx={{mb: 4}}>
        Price History
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid stroke="rgba(0, 0, 0, 0.1)" strokeDasharray="3 3" />
          <XAxis dataKey="displayTime" />
          <YAxis dataKey="price" tickFormatter={(value) => (value === 0 ? '' : value)} />
          <Tooltip
            formatter={(value, name) => [`${currency} ${value}`, name === 'price' ? 'Price' : name]}
            labelFormatter={(value, payload) => {
              const full = payload[0]?.payload?.fullTime;
              return `Date: ${full}`;
            }}
          />
          <Line
            type="linear" //monotone for rounded
            dataKey="price"
            stroke="#1976d2"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
            name="Price"
          />

          <ReferenceLine
            y={targetPrice}
            stroke="#1E90FF" // Dodger blue
            strokeOpacity={0.8} // Makes it more transparent
            strokeDasharray="4 16"
            label={{
              value: `Alert Threshold (${currency} ${targetPrice})`,
              position: 'insideTopRight',
              fill: '#1E90FF',
              fontSize: 12,
              fontWeight: 'bold'
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default PriceChart;
